import React, { useRef, useState, useEffect } from 'react';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import '../css/editor.css';
import '../css/wa.css';
import { fetchUserData } from '../api/getUserData';
import { publishPost } from '../api/postApi'; // Assume you'll create this API function
import axios from "axios";


import { useToast } from "../components/ToastProvider";
import { select } from 'slate';


const MainEditor = () => {
    const [tags, setTags] = useState([]);
    const [input, setInput] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedHeader, setSelectedHeader] = useState('');
    const [title, setTitle] = useState('');
    const [copyProtection, setCopyProtection] = useState(false);
    const inputRef = useRef(null);
    const editorRef = useRef();
    const [editorData, setEditorData] = useState('');
    const [heads, setHeads] = useState([]);
    const showToast = useToast();


    const [categories, setCategories] = useState([]);


    const [isAdmin, setIsAdmin] = useState(false);



    // Similar to previous useEffect for user authentication and fetching tags
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            window.location.href = '/login';
            showToast("로그인 후 사용할 수 있는 기능입니다.", { type: "warn" })
        } else {
            const getUserData = async () => {
                try {
                    const user = await fetchUserData(token);
                    console.log(user);
                    if (user) {
                        const newTags = [user.user.organ, ...JSON.parse(user.user.category)];
                        setTags((prevTags) => [...new Set([...prevTags, ...newTags])]);
                    }
                } catch (err) {
                    console.error('Failed to fetch user data:', err);
                }

                const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/category/fetch`, {});
                setCategories(data.categories);
                setHeads(data.headings);
                

            };
            
            const getAdminData = async () => {
                const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/isAdmin`, { token });
                setIsAdmin(data.isAdmin);
                console.log('ddd', data);
            };
            getAdminData();
            getUserData();
        }
    }, []);

    // Existing tag-related functions (handleInputChange, handleKeyDown, removeTag)
    const handleInputChange = (e) => {
        const value = e.target.value;
        setInput(value);
    };

    const handleKeyDown = (e) => {
        const value = input.trim();
        if (e.key === ' ' && value.startsWith('#')) {
            if (value.length > 1) {
                e.preventDefault();
                const newTag = value.substring(1);
                if (!tags.includes(newTag)) {
                    setTags([...tags, newTag]);
                }
                setInput('');
            }
        }

        if (e.key === 'Backspace' && input === '' && tags.length > 0) {
            const newTags = tags.slice(0, -1);
            setTags(newTags);
        }
    };

    const removeTag = (tagToRemove) => {
        const newTags = tags.filter((tag) => tag !== tagToRemove);
        setTags(newTags);
    };

    // Category and header selection
    const handleCategoryChange = (e, d) => {
        const category = e;
        setSelectedCategory(category);
        if (category !== '카테고리 선택' && !tags.includes(category)) {
            setTags([...tags, d]);
        }
    };

    const handleHeaderChange = (e, d) => {
        const header = e;
        setSelectedHeader(header);
        if (header !== '말머리 선택' && !tags.includes(header)) {
            setTags([...tags, d]);
        }
    };

    // Editor-related functions
    const getSunEditorInstance = (sunEditor) => {
        editorRef.current = sunEditor;
    };

    const handleEditorChange = (content) => {
        setEditorData(content);
    };

    // New publication handler
    const handlePublish = async () => {
        // Validation checks
        if (!title.trim()) {
            alert('제목을 입력해주세요.');
            return;
        }

        if (!selectedCategory || selectedCategory === '카테고리 선택') {
            alert('카테고리를 선택해주세요.');
            return;
        }

        if (!editorData.trim()) {
            alert('내용을 입력해주세요.');
            return;
        }

        try {
            const postData = {
                title: title,
                content: editorData,
                category: selectedCategory,
                header: selectedHeader,
                tags: tags,
                copyProtection: copyProtection,
            };
        
            const response = await publishPost(postData);
        
            if (response && response.articleId) {
                // Redirect to the newly created post
                window.location.href = `/community/article/${response.articleId}`;
            } else {
                alert('글 발행에 실패했습니다. 다시 시도해주세요.');
            }
        } catch (error) {
            console.error('Publication error:', error);
        
            // Handle 401 Unauthorized response
            if (error.response && error.response.status === 401) {
                alert('로그인이 필요합니다. 로그인 페이지로 이동합니다.');
                window.location.href = '/login';
            } else {
                alert('글 발행 중 오류가 발생했습니다.');
            }
        }
        
    };

    return (
        <>
            <div className="ed-flex">
                <div className="ed-main-area">
                    <div className="ed-main-editor">
                        <SunEditor
                            onChange={handleEditorChange}
                            mode="inline"
                            lang="ko"
                            setContents={editorData}
                            placeholder="여기에 내용을 입력해주세요..."
                            setOptions={{
                                height: '700px',
                                minHeight: '700px',
                                placeholder: '여기에 내용을 입력해주세요...',
                                buttonList: [
                                    ['undo', 'redo'],
                                    ['font', 'fontSize', 'formatBlock'],
                                    ['bold', 'italic', 'underline', 'strike', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle'],
                                    ['align', 'horizontalRule', 'list', 'lineHeight'],
                                    ['outdent', 'indent'],
                                    ['table', 'link', 'image', 'video'],
                                    ['blockquote', 'codeView', 'preview', 'print'],
                                    ['fullScreen', 'showBlocks', 'codeView'],
                                ],
                                font: ['Wanted Sans', 'Arial', 'Comic Sans MS', 'Courier New', 'Georgia', 'Tahoma', 'Verdana'],
                                fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36],
                                defaultStyle: 'font-size: 16px; font-family: Arial, sans-serif;',


                            }}
                        />
                    </div>
                </div>
                <div className="ed-side">
                    <div className="wa-card ed-side-tool">
                        <div className="ed-publish-ct">
                            <input
                                type="text"
                                placeholder="제목을 입력하세요"
                                className="ed-title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />




                            
                            <div className='ed-selection'>
                                <p>카테고리 선택</p>   
                                {categories.map((category) => (
                                    <div id={category.id} className={`ed-select-bt ${category.id === selectedCategory ? 'selected' : ''}`} onClick={() => setSelectedCategory(category.id)} 
                                    style={{
                                        borderColor: category.color,
                                        backgroundColor: category.id === selectedCategory ? category.color : 'transparent'
                                      }}
                                    >
                                        {category.name}
                                    </div>
                                ))}   
                            </div>

                            <div className='ed-selection'>
                                <p>말머리 선택</p>   
                                {heads
                                .filter(head => !['NOT', 'EVE'].includes(head.id)) // 제외할 ID 목록
                                .map(head => (
                                    <div
                                    id={head.id}
                                    className={`ed-select-bt ${head.id === selectedHeader ? 'selected' : ''}`}
            k                        onClick={() => setSelectedHeader(head.id)}
                                    style={{
                                        borderColor: head.color,
                                        backgroundColor: head.id === selectedHeader ? head.color : 'transparent',
                                    }}
                                    >
                                    {head.name}
                                    </div>
                                ))}

                            </div>
                            
                            {isAdmin ?
                            <div className='ed-selection'>
                                <p>관리자 말머리 선택</p>   
                                {heads
                                .filter(head => ['NOT', 'EVE'].includes(head.id)) // 제외할 ID 목록
                                .map(head => (
                                    <div
                                    id={head.id}
                                    className={`ed-select-bt ${head.id === selectedHeader ? 'selected' : ''}`}
                                    onClick={() => setSelectedHeader(head.id)}
                                    style={{
                                        borderColor: head.color,
                                        backgroundColor: head.id === selectedHeader ? head.color : 'transparent',
                                    }}
                                    >
                                    {head.name}
                                    </div>
                                ))}

                            </div>
                            : null}
                            
                            {/* Tags Section */}
                            <div className="tag-container">
                                <div className="tag-input-container">
                                    <div className="tag-input-wrapper">
                                        {tags.map((tag, index) => (
                                            <span key={index} className="tag">
                                                #{tag}
                                                <button
                                                    onClick={() => removeTag(tag)}
                                                    className="tag-remove-button"
                                                >
                                                    ×
                                                </button>
                                            </span>
                                        ))}
                                        <input
                                            ref={inputRef}
                                            type="text"
                                            value={input}
                                            onChange={handleInputChange}
                                            onKeyDown={handleKeyDown}
                                            placeholder="#태그 입력 후 스페이스"
                                            className="tag-text-input"
                                        />
                                    </div>
                                </div>
                                <p className="tag-guide-text">
                                    '#'으로 시작하는 텍스트를 입력하고 스페이스바를 누르면 태그가 생성됩니다
                                </p>
                            </div>

                            {/* Copy Protection Checkbox */}
                            <div className="copy-protection-container" style={{ marginBottom: '10px' }}>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={copyProtection}
                                        onChange={(e) => setCopyProtection(e.target.checked)}
                                    />
                                    복사 방지
                                </label>
                            </div>

                            <button 
                                className="ed-publish" 
                                onClick={handlePublish}
                            >
                                발행하기
                            </button>
                        </div>
                    </div>
                    
                    {/* Temporary Save Section */}
                    <div className="wa-card ed-side-tool">
                        <div className="ed-publish-ct">
                            <select className="ed-dropdown">
                                <option>임시저장한 글</option>
                            </select>
                            <div className="ed-flex">
                                <button className="ed-load">불러오기</button>
                                <button className="ed-load">이 글 임시저장</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MainEditor;